import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private _config: Config = new Config();

  constructor(private http: HttpClient) { }

  public listar(grupoEmpresa: Array<number> = []): Observable<any> {
    return this.http.post<any>(`${this._config.get('urlServiceBackend')}monitor/dashboard/listar`, {
        grupoEmpresa: grupoEmpresa
    });
  }

  public listarMapasPorOperador(periodo: string): Observable<any> {
      return this.http.post<any>(`${this._config.get('urlServiceBackend')}monitor/dashboard/operador/listar`, {
          periodo: periodo
      });
  }

  public listarMapasPorOperadorUpdateVsInsert(periodo: string): Observable<any> {
      return this.http.post<any>(`${this._config.get('urlServiceBackend')}monitor/dashboard/operador/update-vs-insert`, {
          periodo: periodo
      });
  }
}
